import { Trans } from '@lingui/react/macro';
import { Box, Button, ScrollArea } from '@pocketlaw/tetris';
import { WorkflowCheckError } from 'app/domains/workflows/features/WorkflowCheckError';
import { useWorkflowCheck } from 'app/domains/workflows/features/WorkflowCheckProvider';
import { AskForApprovalButton } from './AskForApprovalButton';
import { ManualApprovers } from './ManualApprovers';
import { RerunCheckButton } from './RerunCheckButton';
import { useWorkflowApprovers } from './WorkflowApproversProvider';
import { AdvancedApprovalCheckPreview } from '../../../AdvancedApprovalCheckPreview';
import { ActionsFooter, Content, Container, InnerContent } from './styled';
export function ReviewState() {
    const { approvalResult, resetCheck } = useWorkflowCheck();
    const { summary, isApprovalRequired, approvers } = approvalResult;
    const { selectedApproverIds, toggleApprover } = useWorkflowApprovers();
    const suggestedApprovers = approvers.map((approver) => (Object.assign(Object.assign({}, approver), { selected: selectedApproverIds.includes(approver.id), onChange: () => toggleApprover(approver) })));
    const handleCancel = () => {
        resetCheck();
    };
    return (<Container>
      <Content>
        <ScrollArea>
          <InnerContent>
            <WorkflowCheckError />

            <AdvancedApprovalCheckPreview isApprovalRequired={isApprovalRequired} summary={summary} approvers={suggestedApprovers}/>

            <ManualApprovers />
          </InnerContent>
        </ScrollArea>
      </Content>

      <ActionsFooter>
        <Box flexDirection="column" gap="md">
          <AskForApprovalButton />
          <Box gap="md">
            <Button $stretch appearance="secondary" size="small" onClick={handleCancel}>
              <Trans comment="Document approval check - Cancel button label">Cancel</Trans>
            </Button>
            <RerunCheckButton />
          </Box>
        </Box>
      </ActionsFooter>
    </Container>);
}
